export const STEPS = {
  VERIFY: 'VERIFY',
  REDIRECT_TO_LOGIN: 'REDIRECT_TO_LOGIN',
  LINK_RESENT: 'LINK_RESENT',
};
